import { render, staticRenderFns } from "./DistributionDetails.vue?vue&type=template&id=f313bb8c&scoped=true"
import script from "./DistributionDetails.ts?vue&type=script&lang=ts&external"
export * from "./DistributionDetails.ts?vue&type=script&lang=ts&external"
import style0 from "./DistributionDetails.vue?vue&type=style&index=0&id=f313bb8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f313bb8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f313bb8c')) {
      api.createRecord('f313bb8c', component.options)
    } else {
      api.reload('f313bb8c', component.options)
    }
    module.hot.accept("./DistributionDetails.vue?vue&type=template&id=f313bb8c&scoped=true", function () {
      api.rerender('f313bb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/details/DistributionDetails/DistributionDetails.vue"
export default component.exports